<template>
    <router-link :to="{ name: 'artist-detail', params: { slug: artist.person_slug }}">
        <img :src="mediaUrl + '/' + artist.photo" class="column rounded"/>
    </router-link>
</template>

<script>
export default {
    props: {
        artist: Object
    },
    data(){
        return{
            mediaUrl: process.env.VUE_APP_MEDIAURL
        }
    }
}
</script>

<style scoped>
.column {
    width: 100%;
}

</style>